import React from "react";
import { BiHome } from "react-icons/bi";
import { BiUser } from "react-icons/bi";
import { BiBookContent } from "react-icons/bi";
import { BsEnvelope } from "react-icons/bs";
import { BsTelephoneFill } from "react-icons/bs";
import { FaTelegram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { MdFactCheck } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import WebData from "../../../Helpers/WebData";

export const data = [
  {
    id: 1,
    to: "hero",
    toLink: "/",
    name: "home",
    offset: 0,
    icon: <BiHome className="icon" />,
  },
  {
    id: 2,
    to: "about",
    toLink: "#about",
    name: "about",
    offset: 0,
    icon: <BiUser className="icon" />,
  },
  {
    id: 3,
    to: "services",
    toLink: "#services",
    name: "service",
    offset: 0,
    icon: <MdFactCheck className="icon" />,
  },
  {
    id: 4,
    to: "engage",
    toLink: "#engage",
    name: "engage",
    offset: 0,
    icon: <FiSettings className="icon" />,
  },
  {
    id: 5,
    name: "contact",
    toLink: "#contact",
    to: "locate",
    offset: 0,
    icon: <BsEnvelope className="icon" />,
  },
  {
    id: 6,
    toLink: "/shop",
    to: "/shop",
    name: "shop",
    offset: 0,
    icon: <BiBookContent className="icon" />,
  },
];
export const social_links = [
  {
    id: 1,
    link: `${WebData.socialLink.facebook}`,
    icon: <FaFacebook />,
  },
  {
    id: 2,
    link: `${WebData.socialLink.instagram}`,
    icon: <FaInstagram />,
  },
];

export const contact_links = [
  {
    id: 1,
    link: `tel:${WebData.contact.phone}`,
    icon: <BsTelephoneFill />,
  },
  {
    id: 2,
    link: `https://wa.me/${WebData.contact.whatsapp}`,
    icon: <BsWhatsapp />,
  },
  {
    id: 3,
    link: `https://telegram.me/${WebData.contact.telegram}`,
    icon: <FaTelegram />,
  },
  {
    id: 4,
    link: window.matchMedia("(max-width: 786px)").matches
      ? `mailto:${WebData.contact.mail}`
      : "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=samskrithigoshala@gmail.com",
    icon: <BsEnvelope />,
  },
];
